var advmap;
var boundsadvmap;
var markersadvmap = [];
var lastOpenedInfoWindow;


$(function() {
    if (window.location.href.indexOf("#") > -1) {
        var href = window.location.href.split("#")[1];

		if(href === 'richiedi-preventivo') {
			$('#modal_form_quote').modal('show')
		} else {
			$([document.documentElement, document.body]).animate({
				scrollTop: $("#" + href).offset().top - 260
			}, 800 );
		}
    }

    $('a[href*="#"]:not([role])').on("click", function (e) {
        if($(this.hash).length) {
            e.preventDefault();
            $([document.documentElement, document.body]).animate({
                scrollTop: $(this.hash).offset().top - 220,
            }, 500);
        }
    });

    $('a[href*="top-page"]').on("click", function (e) {
        e.preventDefault();
        $([document.documentElement, document.body]).animate(
            { scrollTop: 0 },
            0
        );
    });

    $(".icon-arrow-scroll-to").on("click", function () {
        $([document.documentElement, document.body]).animate(
            {
                scrollTop: $("#row_0_1").offset().top,
            },
            500
        );
    });

    // TAB AUTOMATIC
    var tabChange = function () {
        if ($(window).width() > 959) {
            var tabs = $(".offer-tab .nav-pills > .nav-link");
            var active = tabs.filter(".active");
            var next = active.next(".nav-link").length
                ? active.next(".nav-link")
                : tabs.filter(":first-child");
            // Bootsrap tab show, para ativar a tab
            next.tab("show");
        }
    };
    // Tab Cycle function
    var tabCycle = setInterval(tabChange, 3000);
    // Tab click event handler
    $(function () {
        $(".offer-tab .nav-link").on("click", function (e) {
            if ($(window).width() > 959) {
                //e.preventDefault();
                // Parar o loop
                clearInterval(tabCycle);
                // mosta o tab clicado, default bootstrap
                //$(this).tab('show')
                // Inicia o ciclo outra vez
                setTimeout(function () {
                    tabCycle = setInterval(tabChange, 3000); //quando recomeça assume este timing
                }, 3000);
            }
        });
    });

    $(".filter-structure #filterMenuStructure").on("click", function () {
        $(".car-offer-structure .popup").toggleClass("is-popup-show");
    });

    $(".filter-structure li.dropdown-item").on("click", function () {
        $(".car-offer-structure .popup").removeClass("is-popup-show");
        $("#filterMenuStructure span").text($(this).text());
        $(".carousel-offer-structure").slick("slickUnfilter");
        if ($(this).data("idcms") != "all") {
            $(".carousel-offer-structure").slick(
                "slickFilter",
                ".cstr" + $(this).data("idcms")
            );
        }
    });

    $(".popup").on("click", function () {
        $(".popup").removeClass("is-popup-show");
    });

    //

    $(".select-offer-promo li.dropdown-item").on("click", function () {
        $(".select-offer-promo").addClass("active");
        $(".select-offer-promo button span").text($(this).find("span").text());
    });

    $(".filter-offer-promo li").on("click", function () {
        $(this).addClass("active");
        setTimeout(function () {
            $(".filter-offer-promo li").removeClass("active");
        }, 2000);
    });

    //

    $(".booking-bar-search").on("click", function () {
        $(".form-search-booking").addClass("is-form-search-booking-open");
        //REMOVE E ADD CSS MEDIA
        $(".bar-rotate-offer-promo").removeClass("rotate");
    });

    $(".form-search-booking-icon").on("click", function () {
        $(".form-search-booking").removeClass("is-form-search-booking-open");
        //REMOVE E ADD CSS MEDIA
        // $('.bar-rotate-offer-promo').addClass('rotate');
        // $('.bar-rotate-offer-promo').removeClass('rotate');
    });

    $(".list-destinations").on("click", function () {
        $(".destinations").toggleClass("d-block");
        $(".destinations .card-dropdown-list li").toggleClass("opacity-1");
    });

    $(".list-discover").on("click", function () {
        $(".discover").toggleClass("d-block");
        $(".discover .card-dropdown-list li").toggleClass("opacity-1");
    });

    $(".list-offers").on("click", function () {
        $(".offers").toggleClass("d-block col-4-12");
    });

    $("button.navbar-toggler").on("click", function () {
        $("body").toggleClass("overflow-hidden");
        $(".navbar").toggleClass("is-menu-open");
        // if(!$(".navbar .navbar-collapse.collapse").hasClass("show")) {
        //     console.log('a')
        //     $(".navbar .navbar-collapse.collapse").addClass("show");
        // }
    });

    $(window).on("scroll", function () {
        if (
            window.location.pathname == "/" ||
            window.location.pathname == "/valturcom/public/"
        ) {
            if (window.scrollY > 300 || window.pageYOffset > 300) {
                $(".booking-bar-search").addClass("booking-bar-search-active");
            } else {
                $(".booking-bar-search").removeClass("booking-bar-search-active");
            }
        }
    });

    //  RESPONSIVE
    $(window).on('resize', function () {
        if ($(window).width() > 1100) {
            $("body").removeClass("overflow-hidden");
            $(".navbar").removeClass("is-menu-open");
        }
    });

    // if (window.location.pathname == '/' || window.location.pathname == '/valturcom/public/') {
    //   $('body').addClass('is-home');
    // }

    // $(".dropdown-m").hover(function(){
    //     var dropdownMenu = $(this).children(".dropdown-menu");

    //         dropdownMenu.parent().toggleClass("open");
    //         dropdownMenu.parent().toggleClass("show");
    //         dropdownMenu.parent().find('.dropdown-menu').toggleClass('show')
    //     console.log( dropdownMenu.parent().find('.dropdown-menu'))
    // });

    if (window.location.href.indexOf("?experience=") > -1) {
        $('a[aria-controls^="#str"]').removeClass("active");
        var href = window.location.search.split("?experience=")[1];
        $('a[aria-controls="#str' + href + '"]').tab("show");
        // $('a[aria-controls="#str' + href + '"]').on(
        //     "shown.bs.tab",
        //     function (e) {
        //     }
        //     );
        if ($('a[aria-controls="#str' + href + '"]').length) {
            $("html, body").animate(
                {
                    scrollTop:
                        $(
                            'a[aria-controls="#str' + href + '"]'
                        ).offset().top - 250,
                },
                800,
                function () {}
            );
        }
    }

    if (window.location.href.indexOf("?offer=") > -1 && $(window).load) {
        var href = window.location.search.split("?offer=")[1];

        $(window).on("load", function () {
            if ($('div[id*="' + href + '"].collapse').length) {
                $('div[id*="' + href + '"].collapse').addClass("show");
                $("html, body").animate(
                    {
                        scrollTop:
                            $('div[id*="' + href + '"].collapse').offset().top -
                            260,
                    },
                    1000
                );
            } else if ($('.slick-slider [id*="' + href + '"]').length) {
                $("html, body").animate(
                    {
                        scrollTop: $(".vant" + href).offset().top - 270,
                    },
                    1000
                );
                $(".offer-carousel-tab-slick").slick(
                    "slickGoTo",
                    parseInt($("#" + href).data("slick-index"))
                );
            } else {
                $("html, body").animate(
                    {
                        scrollTop: $('[id^="' + href + '"]').offset().top - 210,
                    },
                    1000
                );
            }
        });
    }

    $(".tab-slick a, .to-tab-slick a").on("click", function (e) {
        e.preventDefault();
        $(".nav-link").removeClass("active");
        $(this).tab("show");
    });

    startcNum();

    function startcNum() {
        $(".carousel-numbers").each(function (i, e) {
            var idcarousel = $(e).data("cid");

            $(e)
                .find(".totalit")
                .text(
                    $("#" + idcarousel + " .carousel-inner .carousel-item")
                        .length
                );

            $("#" + idcarousel).bind("slid.bs.carousel", function () {
                $(e)
                    .find(".current")
                    .text(
                        $(
                            "#" +
                                idcarousel +
                                " .carousel-inner .carousel-item.active"
                        ).index() + 1
                    );
            });
        });
    }

    if ($("#contactmap").length)
        initMapContact($("#contactmap").data("marker"));

    if ($("#destmap").length) initMap(markers);

    if ($("#advmap").length) {
        var lat = "42.188294";
        var lng = "12.677061";
        var myLatLng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
        boundsadvmap = new google.maps.LatLngBounds();
        var myOptions = {
            zoom: 6,
            center: myLatLng,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false,
            panControl: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: true,
            overviewMapControl: false,
            rotateControl: false,
            zoomControl: true,
        };
        advmap = new google.maps.Map(
            document.getElementById("advmap"),
            myOptions
        );
    }

    var toggleAffix = function (affixElement, scrollElement, wrapper, offset) {
        var height = affixElement.outerHeight(),
            top = wrapper.offset().top - offset;

        if (scrollElement.scrollTop() >= top) {
            wrapper.height(height);
            affixElement.addClass("affix");
        } else {
            affixElement.removeClass("affix");
            wrapper.height("auto");
        }
    };

    $('[data-toggle="affix"]').each(function () {
        var offset = $(this).data("offset-top");
        var ele = $(this),
            wrapper = $("<div></div>");

        ele.before(wrapper);
        $(window).on("scroll resize", function () {
            toggleAffix(ele, $(this), wrapper, offset);
        });

        // init
        toggleAffix(ele, $(window), wrapper, offset);
    });

    $("select[name='province']").on("change", function () {
        $(".loadresadv").show();
        var formdata = {};
        formdata["province"] = $(this).val();
        searchAdv(formdata);
    });

    $("#searchadv").on("click", function () {
        $(".loadresadv").show();
        var formdata = {};
        var caploc = $("input[name='caploc']").val();
        var province = $("select[name='province']").val();
        if (caploc) {
            if (/^([0-9]{5})$/.test(caploc)) formdata["cap"] = caploc;
            else formdata["location"] = caploc;
        }

        if (province) {
            formdata["province"] = province;
        }

        searchAdv(formdata);
    });

    $("#gototagblog").on("change", function () {
        if ($(this).val()) location.href = $(this).val();
    });





    $("#form-work").on("submit", function (e) {
        e.preventDefault();
        $("#sendok").hide();
        $("#sendko").hide();
        $.ajax({
            type: "POST",
            url: window.appUrl + "/mail/work",
            dataType: "json",
            data: $(this).serialize(),
            success: function (result) {
                $("#form-work input,#form-work select,#form-work textarea").val(
                    ""
                );
                $("#sendok").show();
            },
            error: function (data) {
                $("#sendko").show();
            },
        });
    });

    $(".lightgallery").lightGallery({
        thumbnail: true,
        selector: ".image:not(.slick-cloned)",
        fullScreen: false,
        animateThumb: false,
        showThumbByDefault: false,
        mode: "lg-fade",
        zoom: false,
        share: false,
        cssEasing: "cubic-bezier(.25, 0, .25, 1)"
    })

    $('.lg_link').on('click', function() {
        $(this).next('.lightgallery').find('.image:first-of-type > img').trigger('click')
    })
    // $('.lg_link.image').on('click', function() {
    //     $(this) > $('.svg').next('.lightgallery').find('.image:first-of-type > img').trigger('click')
    // })
})

function searchAdv(formdata) {
    $.ajax({
        type: "POST",
        url: window.appUrl + "/api/searchadv",
        dataType: "json",
        data: formdata,
        success: function (result) {
            $("#listsadv").empty();
            $("#titlelistsadv").hide();
            $(".alert-advmap").hide();
            var lists = [];
            clearAdvMap();
            if (result.markers.length) {
                initMapAdv(result.markers);
            }
            $(".loadresadv").hide();

            $("html, body").animate(
                {
                    scrollTop: $("#advmap").offset().top - 350,
                },
                800,
                function () {}
            );

            if (!result.advs.length && !result.markers.length) {
                $(".alert-advmap").show();

                $(".alert-advmap").toggleClass("show");
            }
            if (result.advs.length) {
                var html = "";
                result.advs.sort(function (a, b) {
                    if (a.name < b.name) {
                        return -1;
                    }
                    if (a.name > b.name) {
                        return 1;
                    }
                    return 0;
                });
                $.each(result.advs, function (j, l) {
                    if (l.isDiamond) {
                        lists.push(l);
                    }
                });
                $.each(result.advs, function (j, l) {
                    if (!l.isDiamond) {
                        lists.push(l);
                    }
                });

                $("#titlelistsadv").show();
                $.each(lists, function (j, l) {
                    html += '<div class="col-sm-4 mt20 pl10 pr10">';
                    if (l.isDiamond) {
                        html +=
                            '<div class="item-adv-dm gotomap" data-cx="' +
                            l.index +
                            '">';
                    } else html += '<div class="item-adv-n">';
                    html +=
                        '<div class="f-14 fw700 boxnameadv text-uppercase">' +
                        l.name +
                        "</div>";
                    html +=
                        '<div class="f-12 mt10 mb5">' +
                        l.address +
                        "," +
                        l.locality +
                        "</div>";

                    if (l.isDiamond) {
                        html +=
                            '<div  class="f-12 mb5">Tel. ' +
                            l.telephone +
                            "</div>";
                        html += '<div  class="f-12">' + l.email + "</div>";
                        html +=
                            '<div class="f-12 mt5 text-right boxadvsvg"><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 100 100" role="img" aria-labelledby="icon-diamond-agency-description" class="icon-diamond-agency"><path d="M41.31,21.29H32.2l7.64,7.87Zm26.73,0H62.52L60.6,32.42,73.88,27l-4-4.79A2.85,2.85,0,0,0,68,21.29Zm-7,0H42.82l-1.71,9.17L48,37.57l11-4.49ZM40.75,32.35,39.1,41.21l7.34-3ZM30.57,21.86a2.07,2.07,0,0,0-.37.34L17.53,37.34l8.89,9,11-4.52,2-10.82ZM58.66,35l-9.43,3.85,7.45,7.67ZM16.52,38.55,12.77,43a1,1,0,0,0-.09,1.09l.09.13L17.58,50l7.27-3Zm20.59,5.24-9.45,3.86L35,55.11ZM75,28.31l-14.7,6L58,47.82l8.75,9L81.65,51l5.65-6.75a1,1,0,0,0,0-1.22ZM57.93,49.91l-2,11.75,9.8-3.8Zm21.54,3.7L68,58.11l4.16,4.29ZM47.67,39.47l-8.92,3.65L36.27,56.4,45,65.3l9-3.53,2.3-13.36ZM26.09,48.29l-7.41,3L32.61,68l2-11Zm9.83,10L33.84,69.43l.15.18,9.44-3.69Zm17.81,5.38-7.46,2.91,5.92,6Zm12.63-4.94L55.34,63,53.47,73.89l4.88,5L71.1,63.61ZM53.15,75.8l-2,11.67,6.2-7.41Zm-8.47-8.61L35.1,70.93,49.52,88.17,51.87,74.5ZM50,1A49,49,0,1,1,1,50,49,49,0,0,1,50,1Zm1.56,88.39a2.1,2.1,0,0,1-1,.68,1.79,1.79,0,0,1-.51.07,1.87,1.87,0,0,1-.61-.11,2,2,0,0,1-.91-.64l-36.82-44a2.68,2.68,0,0,1-.6-1.74,2.73,2.73,0,0,1,.6-1.75L29.12,21.07a3.69,3.69,0,0,1,.57-.54,4.53,4.53,0,0,1,1-.58A3.52,3.52,0,0,1,32,19.63H68A4.25,4.25,0,0,1,71,21.07L88.37,41.89h0A2.68,2.68,0,0,1,89,43.64a2.64,2.64,0,0,1-.61,1.74Z" fill="#a99579" fill-rule="evenodd"></path></svg></div>';
                    }
                    html += "</div>";
                    html += "</div>";
                });

                $("#listsadv").html(html);

                $(".gotomap").on("click", function () {
                    if (lastOpenedInfoWindow) lastOpenedInfoWindow.close();
                    var index = $(this).data("cx");
                    advmap.setCenter(
                        new google.maps.LatLng(
                            window["marker_" + index].position.lat(),
                            window["marker_" + index].position.lng()
                        )
                    );
                    window["infowindow_" + index].open(
                        advmap,
                        window["marker_" + index]
                    );
                    lastOpenedInfoWindow = window["infowindow_" + index];
                    $("html, body").animate(
                        {
                            scrollTop: $("#advmap").offset().top - 350,
                        },
                        800,
                        function () {}
                    );
                });
            }
        },
        error: function (data) {},
    });
}

function initMapAdv(markers) {
    var icon = new google.maps.MarkerImage(
        window.appUrl + "/images/diamond-agency.png",
        null,
        new google.maps.Point(0, 0),
        new google.maps.Point(30, 34)
    );
    var infoWindow = [];
    if (markers.length) {
        $.each(markers, function (m, mark) {
            var coords = mark["coords"];
            if (coords && typeof coords === "string") {
                var lt = coords.split(",")[0];
                var lg = coords.split(",")[1];

                var position = new google.maps.LatLng(
                    parseFloat(lt),
                    parseFloat(lg)
                );
                window["marker_" + mark.index] = new google.maps.Marker({
                    position: position,
                    map: advmap,
                    icon: icon,
                    title: mark["name"],
                });

                markersadvmap.push({
                    key: "marker_" + mark.index,
                    marker: window["marker_" + mark.index],
                });
                boundsadvmap.extend(position);
                var htmlmap =
                    '<div style="width:250px" class="advmap--infowindow"><h1>' +
                    mark["name"] +
                    "</h1>";
                htmlmap +=
                    '<div class="dark-grey-color f-12 mt10 font-c">' +
                    mark["address"] +
                    ", " +
                    mark["locality"] +
                    "</div>";
                htmlmap +=
                    '<div class="dark-grey-color f-12 font-c"><a class="dark-grey-color" href="tel:' +
                    mark["telephone"] +
                    '">' +
                    mark["telephone"] +
                    "</a></div>";
                htmlmap +=
                    '<div class="dark-grey-color f-12 mt5 font-c"><a class="dark-grey-color" href="mailto:' +
                    mark["email"] +
                    '">' +
                    mark["email"] +
                    "</a></div>";

                htmlmap += "</div>";

                window["infowindow_" + mark.index] = new google.maps.InfoWindow(
                    {
                        content: htmlmap,
                    }
                );

                google.maps.event.addListener(
                    window["marker_" + mark.index],
                    "click",
                    function () {
                        if (lastOpenedInfoWindow) lastOpenedInfoWindow.close();
                        window["infowindow_" + mark.index].open(
                            advmap,
                            window["marker_" + mark.index]
                        );
                        lastOpenedInfoWindow =
                            window["infowindow_" + mark.index];
                    }
                );
            }
        });
        if (boundsadvmap.getNorthEast().equals(boundsadvmap.getSouthWest())) {
            var extendPoint1 = new google.maps.LatLng(
                boundsadvmap.getNorthEast().lat() + 0.01,
                boundsadvmap.getNorthEast().lng() + 0.01
            );
            var extendPoint2 = new google.maps.LatLng(
                boundsadvmap.getNorthEast().lat() - 0.01,
                boundsadvmap.getNorthEast().lng() - 0.01
            );
            boundsadvmap.extend(extendPoint1);
            boundsadvmap.extend(extendPoint2);
        }
        advmap.fitBounds(boundsadvmap);
        // var listener = google.maps.event.addListener(advmap, "idle", function() {
        //   if (advmap.getZoom() > 12) advmap.setZoom(12);
        //   google.maps.event.removeListener(listener);
        // });
    }
}

function initMap(markers) {
    var lat = "42.188294";
    var lng = "12.677061";
    var myLatLng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
    var bounds = new google.maps.LatLngBounds();
    var icon = "";
    var myOptions = {
        zoom: 6,
        center: myLatLng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        panControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: true,
        overviewMapControl: false,
        rotateControl: false,
        zoomControl: true,
    };
    var icon = new google.maps.MarkerImage(
        window.appUrl + "/images/icon-map-valtur.png",
        null,
        new google.maps.Point(0, 0),
        new google.maps.Point(35, 35)
    );

    var map = new google.maps.Map(
        document.getElementById("destmap"),
        myOptions
    );
    var infoWindow = [];

    $.each(markers, function (m, mark) {
        var coords = mark["coords"];
        if (coords && typeof coords === "string") {
            var lt = coords.split(",")[0];
            var lg = coords.split(",")[1];
            var position = new google.maps.LatLng(
                parseFloat(lt),
                parseFloat(lg)
            );
            window["marker_" + m] = new google.maps.Marker({
                position: position,
                map: map,
                icon: icon,
                title: mark["name"],
            });
            bounds.extend(position);
            var htmlmap =
                '<div style="width:250px"> <div><img src="' +
                mark["img"] +
                '" style="height:150px;width:250px"></div>';
            htmlmap +=
                '<div class="dark-grey-color f-18 mt10 font-c"><span class="f-24 fw700">' +
                mark["title"] +
                "</span><br>" +
                mark["subtitle"] +
                "</div>";
            htmlmap +=
                '<div class="f-18 mt10 dark-grey-color font-c"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 100 100" role="img" aria-labelledby="icon-icon-mapmarker-description" class="icon-icon-mapmarker"><path d="M50 0a33.12 33.12 0 0 0-33.33 32.9 32.41 32.41 0 0 0 3.6 14.88L50 100l29.73-52.22a32.41 32.41 0 0 0 3.6-14.88A33.12 33.12 0 0 0 50 0zm0 51.17A18.28 18.28 0 1 1 68.52 32.9 18.4 18.4 0 0 1 50 51.17z" fill-rule="evenodd"></path></svg>';
            htmlmap +=
                '<span style="padding-left:10px">' +
                mark["locality"] +
                " (" +
                mark["region"] +
                ")</span></div>";
            htmlmap +=
                '<div><a href="' +
                mark["link"] +
                '" class="card-simple--button">Scopri</a></div>';

            htmlmap += "</div>";

            infoWindow[m] = new google.maps.InfoWindow({
                content: htmlmap,
            });

            google.maps.event.addListener(
                window["marker_" + m],
                "click",
                function () {
                    infoWindow[m].open(map, window["marker_" + m]);
                }
            );
        }
    });
    if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
        var extendPoint1 = new google.maps.LatLng(
            bounds.getNorthEast().lat() + 0.01,
            bounds.getNorthEast().lng() + 0.01
        );
        var extendPoint2 = new google.maps.LatLng(
            bounds.getNorthEast().lat() - 0.01,
            bounds.getNorthEast().lng() - 0.01
        );
        bounds.extend(extendPoint1);
        bounds.extend(extendPoint2);
    }
    map.fitBounds(bounds);
    var listener = google.maps.event.addListener(map, "idle", function () {
        if (map.getZoom() > 9) map.setZoom(9);
        google.maps.event.removeListener(listener);
    });
}

function initMapContact(marker) {
    var lat = "42.188294";
    var lng = "12.677061";
    var myLatLng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
    var bounds = new google.maps.LatLngBounds();
    var icon = "";
    var myOptions = {
        zoom: 6,
        center: myLatLng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        panControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: true,
        overviewMapControl: false,
        rotateControl: false,
        zoomControl: true,
    };

    var icon = new google.maps.MarkerImage(
        window.appUrl + "/images/icon-map-valtur.png",
        null,
        new google.maps.Point(0, 0),
        new google.maps.Point(35, 35)
    );

    var contactmap = new google.maps.Map(
        document.getElementById("contactmap"),
        myOptions
    );

    var coords = marker["coords"];
    if (coords && typeof coords === "string") {
        var lt = coords.split(",")[0];
        var lg = coords.split(",")[1];
        var position = new google.maps.LatLng(parseFloat(lt), parseFloat(lg));
        var marker = new google.maps.Marker({
            position: position,
            map: contactmap,
            icon: icon,
        });
        bounds.extend(position);
    }
    if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
        var extendPoint1 = new google.maps.LatLng(
            bounds.getNorthEast().lat() + 0.01,
            bounds.getNorthEast().lng() + 0.01
        );
        var extendPoint2 = new google.maps.LatLng(
            bounds.getNorthEast().lat() - 0.01,
            bounds.getNorthEast().lng() - 0.01
        );
        bounds.extend(extendPoint1);
        bounds.extend(extendPoint2);
    }
    contactmap.fitBounds(bounds);
}

function clearAdvMap() {
    $.each(markersadvmap, function (m, mark) {
        mark.marker.setMap(null);
        delete window[mark.key];
    });
    advmap.setZoom(6);
    advmap.setCenter(new google.maps.LatLng(42.188294, 12.677061));
    markersadvmap = [];
    boundsadvmap = new google.maps.LatLngBounds();
}




function filterStructureList(event, typeForm) {
	const selected = event.target.value !== '' ? event.target.value.split('_')[1] : ''
	const selector = typeForm === 'quote' ? 'quote_form_hotel' : 'contact_form_hotel'
	if(selected !== '') {
		$(`select#${selector} > option`).hide()
		$(`select#${selector} > option[data-country="${selected}"]`).show()
		$(`select#${selector} > option[data-region="${selected}"]`).show()
	} else {
		$(`select#${selector} > option`).show()
	}
}

window.filterStructureList = filterStructureList
